import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { getAvailablePages } from 'utils';

import { SiteConfigManager, useBetslipState } from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';
import { MenuItem } from '@atlas/ui';

import history from 'components/MainRouter/history';

const { CLIENT_PROFILE } = COMPONENT_TYPES;

const ClientProfileSubNavigation = ({ availableTabs, parentRoute, tabs = [] }) => {
  const { settings } = useBetslipState();
  const clientProfilePath = SiteConfigManager.getComponentPath(CLIENT_PROFILE);

  const processedTabs = useMemo(
    () =>
      settings.orderBet
        ? getAvailablePages(availableTabs, tabs)
        : getAvailablePages(availableTabs, tabs).filter(tab => tab.type !== 'myOrders'),
    [tabs],
  );

  return (
    <div>
      {processedTabs.map(({ icon, link, name }) => (
        <MenuItem
          className="menu-item-container"
          icon={icon}
          key={link}
          onClick={() => history.push(`${clientProfilePath}/${parentRoute}/${link}`)}
          renderArrow
          text={name}
        />
      ))}
    </div>
  );
};

ClientProfileSubNavigation.propTypes = {
  availableTabs: PropTypes.object.isRequired,
  parentRoute: PropTypes.string.isRequired,
  tabs: PropTypes.array,
};

export default ClientProfileSubNavigation;
